import { useState, useEffect } from "react";

export interface InstaImage {
  src: string;
  type: "image" | "video";
  url: string;
  date: string;
  title: string;
  icon: string;
}

interface IGMediaItem {
  id: string;
  media_url: string;
  media_type: "IMAGE" | "VIDEO" | "CAROUSEL_ALBUM";
  permalink: string;
  timestamp: string;
  caption?: string;
}


export const useInstagramPosts = (limit = 6) => {
  const [posts, setPosts] = useState<InstaImage[]>([]);
  const token = process.env.REACT_APP_IG_ACCESS_TOKEN!;
  const endpoint = `https://graph.instagram.com/me/media?` +
    `fields=id,media_url,media_type,permalink,timestamp,caption&` +
    `access_token=${token}&limit=${limit}`;

  useEffect(() => {
    const fetchPosts = async () => {
      try {
        const res = await fetch(endpoint);
        const json = await res.json();
        if (json.error) throw new Error(json.error.message);
        const items: IGMediaItem[] = json.data;
        const formatted: InstaImage[] = items.map((p) => ({
          src: p.media_url,
          type: p.media_type === "VIDEO" ? "video" : "image",
          url: p.permalink,
          date: new Date(p.timestamp).toLocaleDateString("ja-JP", {
            year: "numeric",
            month: "numeric",
            day: "numeric",
          }),
          title: p.caption ? p.caption.split("\n")[0] : "",
          icon: "", // アイコンがあればここで設定
        }));
        setPosts(formatted);
      } catch (e) {
        console.error("Instagram fetch error:", e);
      }
    };
    fetchPosts();
  }, [endpoint]);

  return posts;
};
